module.exports = __webpack_public_path__ + "static/media/comercio.78bda084.jpg";